<template>
  <div class="graph-wrapper">
    <div class="graph">
      <div v-for="(player,index) in getAnswerDistribution">
          <div class="column-wrapper" :class="{ 'choicer2': player.id === playerId,'choicer': player.id !== playerId }">
              <div :class="{ 'column2': player.id === playerId,'column': player.id !== playerId }" :style="'height:'+height(index+1)+'%'">
                  <div class="symbol1">
                      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><title>avatar</title><circle class="cls-1" cx="128" cy="128" r="120"/><circle class="cls-2" cx="128" cy="128" r="102.5"/><path class="cls-1" d="M180.74,209.66l-9.09-33a5.37,5.37,0,0,1,3.41-1,5.37,5.37,0,0,0,3.88-9.35,5.36,5.36,0,0,1,0-8,5.38,5.38,0,0,0-3.88-9.36,5.37,5.37,0,0,1-5.63-5.64,5.38,5.38,0,0,0-9.36-3.87,5.37,5.37,0,0,1-8,0,5.38,5.38,0,0,0-9.24,2.42,30.77,30.77,0,0,0-17.08-6v0l-9.35-4v-7.38A23.66,23.66,0,0,0,130.76,111c.39-.39.78-.79,1.15-1.2.21,0,.41,0,.62,0a7.6,7.6,0,0,0,6.21-12A31.21,31.21,0,0,0,128,64.2h0l-.26-.21h0l-.27-.2,0,0-.27-.2h0l-.29-.2h0c-.66-.47-1.34-.91-2-1.32l0,0-.24-.15-.07,0a1.71,1.71,0,0,1-.23-.13l-.09-.05-.22-.12-.1-.05-.21-.12-.11-.06-.21-.11-.11-.06L123,61,122.9,61l-.2-.1-.12-.06-.21-.11-.11-.05-.22-.1-.12-.06-.21-.09-.12-.06-.21-.09-.12,0-.21-.09-.15-.06-.7-.28L120,59.7l-.16-.06-.19-.07-.16-.06-.18-.06-.17-.06-.19-.07-.16,0-.19-.06-.16-.06-.19-.06-.16-.05-.21-.06-.14,0-.22-.06-.14-.05-.21,0-.16-.05-.22,0-.13,0-.24-.06-.13,0-.24-.06-.13,0-.27-.06-.09,0-.34-.07h0l-.75-.14h-.08l-.3-.06H114l-.28,0h-.1l-.27,0-.13,0-.25,0-.13,0-.25,0h-.13l-.25,0h-.14l-.24,0h-.15l-.24,0h-.14l-.25,0h-3.32l-.37,0h0l-.39,0h0l-.34,0h-.09l-.28,0h-.1l-.3,0h-.07l-.37,0h0l-.33,0-.11,0-.25,0-.12,0-.27,0h-.08l-.72.12-.1,0-.26,0-.11,0-.25,0-.11,0-.31.07h0l-.35.08-.09,0-.25.06-.13,0-.23.06-.12,0-.25.07-.09,0-.34.1-.07,0-.26.07L100,59l-.21.06-.14.05-.21.06-.12,0-.3.1-.12,0-.23.08-.15.05-.18.07-.15,0-.18.07-.15.06-.19.07-.18.07-.25.1-.15.06-.17.07-.16.07-.14.06-.18.08-.13.06-.64.29-.13.06-.18.09-.12.06-.18.09-.12.06-.19.1,0,0-.43.23-.09,0-.18.1-.12.07-.18.1-.1.06-.19.1-.09,0-.45.27h0l-.2.12-.09.06a1.18,1.18,0,0,1-.19.11l-.09.06-.19.13,0,0-.67.44-.07,0-.19.14-.08,0-.19.14-.07,0A31.18,31.18,0,0,0,78.65,81.63v0l-.06.26,0,.08-.06.25a.29.29,0,0,1,0,.09,2,2,0,0,1,0,.24s0,.06,0,.09l-.15.78a.51.51,0,0,1,0,.13l0,.21,0,.15,0,.19a1.1,1.1,0,0,0,0,.18l0,.17,0,.22a1.37,1.37,0,0,1,0,.19c0,.09,0,.19,0,.29s0,.1,0,.15l0,.21s0,.11,0,.16,0,.14,0,.21,0,.1,0,.15,0,.16,0,.23,0,.09,0,.14,0,.24,0,.35h0c0,.12,0,.24,0,.37v.12c0,.08,0,.16,0,.25v.13a2.18,2.18,0,0,0,0,.25V88a2.26,2.26,0,0,0,0,.26v1.07a31.57,31.57,0,0,0,1.33,8.47,7.6,7.6,0,0,0,6.21,12c.2,0,.41,0,.61,0,.38.41.77.81,1.16,1.2.28.68.6,1.35.94,2l.27.5a23,23,0,0,0,1.7,2.62c.34.46.69.9,1.07,1.33.24.28.5.56.76.83l.39.41.61.59.42.38c.21.19.43.37.65.55a23.33,23.33,0,0,0,7.51,4.17h0v7.39l-4.67,2-4.68,2v0a30.87,30.87,0,0,0-23.36,12.26h0c-.37.49-.72,1-1.06,1.5l0,0c-.25.38-.5.76-.74,1.16h0c-.07.13-.14.25-.22.37l0,0c-.23.39-.45.79-.66,1.19,0,0,0,0,0,0l-.18.35,0,.07c-.07.12-.13.25-.19.37v0c-.13.27-.26.55-.38.83l0,.05-.15.35a.2.2,0,0,1,0,.08l-.15.36,0,0-.33.84,0,.08-.12.33,0,.11-.12.35s0,0,0,.06c-.1.28-.19.57-.28.85l0,.11c0,.1-.07.21-.1.32l0,.12c0,.11-.06.22-.1.33l0,.09c-.08.29-.15.58-.22.87l0,.11c0,.11,0,.21-.08.32l0,.13c0,.11,0,.22-.07.33a.43.43,0,0,1,0,.11c-.06.29-.11.58-.17.87l0,.14c0,.1,0,.2,0,.31l0,.14c0,.11,0,.22,0,.33l0,.12c0,.29-.08.59-.11.88,0,.05,0,.1,0,.15l0,.3v.16l0,.31v.15c0,.29,0,.59-.06.89a.76.76,0,0,1,0,.15c0,.1,0,.21,0,.31a.86.86,0,0,1,0,.16v.46c0,.15,0,.3,0,.46v14.2a6.77,6.77,0,0,0,6.77,6.77h68.18l-6,22a1,1,0,0,0,.26,1l0,0,.13.1.1.06.14.06a1,1,0,0,0,1-.2l8-6.94.05,0h0l0,0,0,0,0,0h0l0,0h0l0,0h.16l.07,0h.26a1,1,0,0,1,.92.72l3.31,10a1,1,0,0,0,2-.05l7-25.55,1-3.49,8,29a1.05,1.05,0,0,0,2,.05l3.3-10a1,1,0,0,1,.92-.72h.26l.07,0h.16l0,0h0l0,0h0l0,0h0l0,0h0l0,0,8,6.94a1,1,0,0,0,1,.2l.18-.08.13-.09.15-.14,0,0a1,1,0,0,0,.2-.92Zm-72.11-84.08h0Zm-.32,0h0Zm-.92,0-.21,0Zm-.3,0-.19,0Zm-.28,0-.21,0Zm-.28,0-.26,0Zm-.37,0h0Zm-.28,0-.13,0Zm-.27,0h0Zm-.46-.07h0Zm-.21,0-.09,0Zm-.26,0h0Zm-.26,0h0Zm-.68-.14h0Zm-.23,0h0Zm-1.15-.31Zm5.1.89.56,0Zm1.2,0h0Zm5.75-.64h0Zm-.92.2h0Zm-.26,0h0Zm-.26,0,.08,0Zm-.21,0h0Zm-.46.07h0Zm-.27,0,.13,0Zm-.26,0h0Zm-.35,0h0l.26,0Zm-.32,0,.21,0Zm-.29,0,.19,0Zm-.29,0,.21,0Zm-.64,0,.57,0Zm-.28,0h0Zm-.32,0h0Zm7.16,9v0Z"/><path class="cls-3" d="M148.6,180.67H69.3a6.77,6.77,0,0,1-6.77-6.77V159.7a30.92,30.92,0,0,1,30.92-30.92h31a30.92,30.92,0,0,1,30.92,30.92v14.2A6.77,6.77,0,0,1,148.6,180.67Z"/><path class="cls-4" d="M141.77,134.08v46.59h6.83a6.78,6.78,0,0,0,6.78-6.77V159.7a30.89,30.89,0,0,0-13.61-25.62Z"/><path class="cls-5" d="M125.79,128.78l-9.35-4v4L109,140.44l-7.48-11.66v-4l-9.35,4L109,174.46h0Z"/><path class="cls-6" d="M92.12,128.78l7.07,19.16a1.12,1.12,0,0,0,1.85.41l7.91-7.91-7.48-11.66v-4Z"/><path class="cls-6" d="M125.79,128.78l-7.07,19.16a1.13,1.13,0,0,1-1.86.41L109,140.44l7.49-11.66v-4Z"/><path class="cls-7" d="M109,118.58a23.73,23.73,0,0,1-7.48-1.21v11.41L109,140.44l7.49-11.66V117.37A23.75,23.75,0,0,1,109,118.58Z"/><path class="cls-8" d="M115.22,146.71l-4.67,4.66a2.26,2.26,0,0,1-3.19,0l-4.67-4.66,6.26-6.27Z"/><path class="cls-3" d="M110.55,151.37a2.26,2.26,0,0,1-3.19,0l-1.6-1.6L104.37,162,109,174.47,113.54,162l-1.39-12.26Z"/><path class="cls-8" d="M86.87,148.85l4-3.51a1.13,1.13,0,0,0-.62-2l-4.68-.5a1.13,1.13,0,0,1-.94-1.51l4.44-12.26a26.5,26.5,0,0,1,3.08-.28L109,174.47l-22.16-24A1.13,1.13,0,0,1,86.87,148.85Z"/><path class="cls-8" d="M131,148.85l-4-3.51a1.13,1.13,0,0,1,.63-2l4.68-.5a1.14,1.14,0,0,0,.94-1.51l-4.45-12.26a26.11,26.11,0,0,0-3.08-.28L109,174.47l22.17-24A1.13,1.13,0,0,0,131,148.85Z"/><path class="cls-8" d="M136.43,171.29H121.19a1.59,1.59,0,0,0,0,3.17h15.24a1.59,1.59,0,1,0,0-3.17Z"/><path class="cls-9" d="M76.13,180.67V134.08a30.91,30.91,0,0,0-13.6,25.62v14.2a6.77,6.77,0,0,0,6.77,6.77Z"/><circle class="cls-10" cx="109" cy="81.8" r="31.13"/><path class="cls-6" d="M109,118.58A23.58,23.58,0,0,1,85.37,95V82.75a23.58,23.58,0,0,1,47.16,0V95A23.58,23.58,0,0,1,109,118.58Z"/><path class="cls-5" d="M109,118.58a23.73,23.73,0,0,1-7.48-1.21v4.49a23.39,23.39,0,0,0,15,0v-4.49A23.75,23.75,0,0,1,109,118.58Z"/><path class="cls-6" d="M85.37,95V87.63a7.6,7.6,0,0,0,0,15.19,7.83,7.83,0,0,0,1.29-.11A23.71,23.71,0,0,1,85.37,95Z"/><path class="cls-6" d="M132.53,87.63V95a23.45,23.45,0,0,1-1.29,7.71,7.83,7.83,0,0,0,1.29.11,7.6,7.6,0,1,0,0-15.19Z"/><path class="cls-7" d="M109,115.19A23.58,23.58,0,0,1,85.37,91.61V95a23.58,23.58,0,0,0,47.16,0V91.61A23.57,23.57,0,0,1,109,115.19Z"/><path class="cls-7" d="M85.37,82.75V87.4a31.08,31.08,0,0,0,15.47-26.76A23.57,23.57,0,0,0,85.37,82.75Z"/><path class="cls-7" d="M121.31,88.24a31,31,0,0,0,11.22-2.11V82.75a23.55,23.55,0,0,0-40.82-16A31.12,31.12,0,0,0,121.31,88.24Z"/><path class="cls-3" d="M90.35,56.85a31.13,31.13,0,0,0,49.57,21.83A31.11,31.11,0,0,0,90.35,56.85Z"/><path class="cls-9" d="M77.83,81.79A31.73,31.73,0,0,0,78.12,86a31.11,31.11,0,0,0,22.73-30,31.73,31.73,0,0,0-.29-4.17A31.11,31.11,0,0,0,77.83,81.79Z"/><path class="cls-3" d="M101.78,91.91a2.86,2.86,0,1,1-2.86-2.86A2.86,2.86,0,0,1,101.78,91.91Z"/><path class="cls-3" d="M123.94,91.91a2.86,2.86,0,1,1-2.86-2.86A2.86,2.86,0,0,1,123.94,91.91Z"/><path class="cls-7" d="M85.37,95V90.86a4.37,4.37,0,0,0,0,8.73,3.26,3.26,0,0,0,.45,0A23.46,23.46,0,0,1,85.37,95Z"/><path class="cls-7" d="M132.56,95V90.86a4.37,4.37,0,0,1,0,8.73,3.26,3.26,0,0,1-.45,0A23.46,23.46,0,0,0,132.56,95Z"/><path class="cls-11" d="M146.09,207.29l-3.3-10a1,1,0,0,0-1.68-.46l-8,6.93a1,1,0,0,1-1.7-1.06l10.86-39.5L159,167.74l-10.86,39.5a1.05,1.05,0,0,1-2,0Z"/><path class="cls-12" d="M142.29,163.16l-10.86,39.5a1,1,0,0,0,1.7,1.06l8-6.93a1,1,0,0,1,.76-.26l8.52-31.14Z"/><path class="cls-11" d="M166.07,207.29l3.31-10a1,1,0,0,1,1.68-.46l8,6.93a1,1,0,0,0,1.69-1.06l-10.85-39.5-16.67,4.58,10.86,39.5a1,1,0,0,0,2,0Z"/><path class="cls-12" d="M180.74,202.66l-10.86-39.5-8.1,2.23,8.52,31.14a1,1,0,0,1,.76.26l8,6.93a1,1,0,0,0,1.7-1.06Z"/><path class="cls-13" d="M142.29,163.16l-3,11a5.37,5.37,0,0,1,3.48,5.31,5.37,5.37,0,0,0,9.36,3.87,5.31,5.31,0,0,1,3-1.68L159,167.74Z"/><path class="cls-13" d="M172.91,174.19l-3-11-16.67,4.58L157,181.69a5.31,5.31,0,0,1,3,1.68,5.37,5.37,0,0,0,9.35-3.87,5.39,5.39,0,0,1,3.49-5.31Z"/><path class="cls-12" d="M160.07,132.43a5.38,5.38,0,0,1,9.36,3.87,5.37,5.37,0,0,0,5.63,5.64,5.37,5.37,0,0,1,3.88,9.35,5.37,5.37,0,0,0,0,8,5.37,5.37,0,0,1-3.88,9.35,5.38,5.38,0,0,0-5.64,5.64,5.37,5.37,0,0,1-9.35,3.88,5.36,5.36,0,0,0-8,0,5.38,5.38,0,0,1-9.36-3.88,5.37,5.37,0,0,0-5.64-5.64,5.37,5.37,0,0,1-3.87-9.35,5.38,5.38,0,0,0,0-8,5.37,5.37,0,0,1,3.87-9.35,5.37,5.37,0,0,0,5.64-5.64,5.38,5.38,0,0,1,9.36-3.87,5.37,5.37,0,0,0,8,0Z"/><circle class="cls-11" cx="156.15" cy="155.25" r="17.46"/><circle class="cls-13" cx="156.09" cy="155.28" r="13.53"/><path class="cls-14" d="M158.08,147.54l.73,2.26a2.09,2.09,0,0,0,2,1.45h2.39a2.1,2.1,0,0,1,1.23,3.79l-1.93,1.4a2.1,2.1,0,0,0-.76,2.34l.74,2.27a2.1,2.1,0,0,1-3.23,2.34l-1.93-1.4a2.1,2.1,0,0,0-2.46,0l-1.93,1.4a2.09,2.09,0,0,1-3.22-2.34l.73-2.27a2.07,2.07,0,0,0-.76-2.34l-1.92-1.4a2.09,2.09,0,0,1,1.23-3.79h2.38a2.08,2.08,0,0,0,2-1.45l.74-2.26A2.1,2.1,0,0,1,158.08,147.54Z"/></svg>
                      <span class="marks">{{player.points}}</span>
                  </div>
              </div>
              <span class="name">{{player.nickname}}</span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {scoresByPlayer} from "./scoreHelpers"
export default {
  mounted() {
      scoresByPlayer();
  },
  filters: {
      ifInArray: function (value) {
          return this.getAnswerDistribution.indexOf(value) > -1 ? this.getAnswerDistribution[value] : '??';
      }
  },
  computed: {
    playerId() {
      let player = Number(this.$store.state.scores.playerOne.id);
      let team = Number(this.$store.state.scores.playerOne.team_id);
      if (team)
      {
        player = team;
      }

      return player;
    },
    getAnswerDistribution() {
        function getElByPropVal(myArray, prop, val){
            for (let i = 0, length = myArray.length; i < length; i++) {
                if (myArray[i][prop] === val){
                    return myArray[i];
                }
            }

            return false;
        }
        const currentPLayer = getElByPropVal(this.$store.state.players,'id',this.playerId);
        let top_players = this.$store.state.players.slice(0,5);
        if (getElByPropVal(top_players,'id',this.playerId))
        {
            return top_players;
        }else
        {
            top_players.pop();
            top_players.push(currentPLayer);
            return top_players;
        }
    }
  },
  methods:{
      height(key)
      {
          let height;
          if (key===1)
          {
              height=100
          }
          if (key===2)
          {
              height=90
          }
          if (key===3)
          {
              height=80
          }
          if (key===4)
          {
              height=70
          }
          if (key===5)
          {
              height=60
          }
          return height;
      },
  }
};
</script>
<style scoped>.cls-1{fill:#93278f;}.cls-2{fill:#fbb03b;}.cls-3{fill:#00a99d;}.cls-4{fill:#009add;}.cls-5{fill:#d1d3d4;}.cls-6{fill:#fff;}.cls-7{fill:#e6e7e8;}.cls-8{fill:#00bfac;}.cls-9{fill:#02897c;}.cls-10{fill:#036d60;}.cls-11{fill:#f7cb15;}.cls-12{fill:#fede3a;}.cls-13{fill:#e7ad27;}.cls-14{fill:#fff335;}</style>
<style lang="sass" scoped>
@import '../../styles/symbols.sass'

.name
  font-size: 10px
.marks
  color: #fff
.symbol1
  text-align: center
.graph-wrapper
  height: 100%
  width: 100%
  display: grid
  flex-direction: column
  justify-content: center

.graph
  display: grid
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr
  justify-content: center
.column-wrapper
  flex: 1
  display: flex
  flex-direction: column
  justify-content: flex-end
  align-items: center
  height: 100%
  padding: 0 0.75rem
  padding-top: 2.5rem

.column
  position: relative
  width: 100%
  max-height: 100%
  min-height: 2%
  border-top-left-radius: 50px
  border-top-right-radius: 50px
  background: -webkit-linear-gradient($color-purple, $color-white)
.column2
    position: relative
    width: 100%
    max-height: 100%
    min-height: 2%
    border-top-left-radius: 50px
    border-top-right-radius: 50px
    background: -webkit-linear-gradient(#fbb03b, $color-white)

.choicer
  .column
    background: -webkit-linear-gradient($color-purple, $color-white)
.choicer2
  .column2
    background: -webkit-linear-gradient(#fbb03b, $color-white)

.symbol svg
  height: 1.75rem

.player-answer
  position: absolute
  /*top: -2.5rem*/
  left: calc((100% - 2.5rem) / 2)
  svg
    height: 2.5rem

.is-correct
  fill: $color-green

.is-wrong
  fill: $color-red
</style>
